<template>
    <el-dialog title="设备详情" custom-class="device" :close-on-click-modal="false" :visible="dialogVisible"
        @close="$emit('closeDetail')">

        <div class="container" v-loading="loading" v-if="loading"></div>
        <div class="container" v-else>
            <div class="container-left">
                <div class="equipment-header">
                    <div class="equipment-image">
                        <img :src="checkedDevicesInfo.img" />
                    </div>
                    <div class="equipment-infomation">
                        <div class="equipment-infomation-title">
                            <span>{{checkedDevicesInfo.deviceName}}</span>
                            <template v-if="classify === '网关设备'">
                                <span style="color: #68D86A" v-if="isOnline">在线</span>
                                <span style="color: #FD4283" v-else>离线</span>
                            </template>
                        </div>
                        <div class="equipment-infomation-content">
                            <div>类型: {{checkedDevicesInfo.type}}</div>
                            <div>型号: {{checkedDevicesInfo.modelNumber}}</div>
                            <div>站点: {{checkedDevicesInfo.siteName}}</div>
                        </div>
                    </div>
                </div>
                <div class="equipment-timer" v-if="lastdate">
                    <div class="all-item">
                        <div class="yuan">
                            <div class="ball"  :class="iserror?'error':''">
                                <div class="b-top" v-if="num > 0" :style="'bottom:' + (num) +  '%'"></div>
                                <div class="b-content" :style="'top:' + (100 - num) +  '%'"></div>
                            </div>
                            <div class="text">健康</div>
                        </div>
                        <div class="titme">
                            <span>{{lastdate}}</span>
                            <h2 style="color:#5AD8A6;margin: 0 2px;">{{titme}}</h2>
                            <span>天</span>
                        </div>
                    </div>
                </div>
                <div class="diagramContainer">
                    <div class="header">单线图<span style="font-size: 14rem; color: #999; font-weight:400">
                            (鼠标滚轮进行缩放)</span></div>
                    <div class="diagram">
                        <iframe v-if="this.checkedDevicesInfo.svg" :src="this.checkedDevicesInfo.svg"
                            frameborder="0"></iframe>
                        <span v-else>暂无数据</span>
                    </div>
                </div>
                <!-- <div class="equipment-parameter"></div> -->
            </div>
            <div class="container-right">
                <EquipmentCollapse :data="details" @Arr="Arr"></EquipmentCollapse>
                <!-- <div class="container-tree">
                    <EquipmentTree :data="loopInfomation"></EquipmentTree>
                </div> -->
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import EquipmentCollapse from './EquipmentCollapse';
    import EquipmentTree from './EquipmentTree';

    import {
        GetWireByDeviceID
    } from '../../../api/equipment'

    export default {
        components: {
            EquipmentCollapse,
            EquipmentTree
        },
        props: {

            dialogVisible: Boolean,
            checkedInit: String,
            checkedDevicesDetails: String,
            checkedDevicesInfo: Object,
            loopInfomation: Array,
            detailStatus: String,
            isOnline: Boolean,
            classify: String,
        },
        mounted() {

        },
        data() {
            return {
                titme: "",
                lastdate: "",
                num: 80,
                iserror:false,
                // checked: this.checkedInit,
                dataforId: '123',
            }
        },
        computed: {
            // isActive: function () {
            //     return this.checked === 'device';
            // },

            loading: function () {
                return this.detailStatus === 'loading';
            },
            details: function () {
                let temp = '';
                try {
                    temp = JSON.parse(this.checkedDevicesDetails);
                } catch (error) {
                    console.error(error);
                }
                return temp;
            }
        },
        methods: {
            Arr(arr) {
                let a = arr["其他"].购买时间
                a = a.split('-')
             
                this.lastdate = "自" + `${a[0]}` + '年' + `${a[1]}` + '月' + `${a[2]}` + '日起' + '，' + '已运行'
                    this.titme=this.getDistanceSpecifiedTime(arr["其他"].购买时间)
            },

            getDistanceSpecifiedTime(dateTime) {
                var EndTime = new Date(dateTime);
                var NowTime = new Date();
                var t = NowTime.getTime() - EndTime.getTime();
                var d = Math.floor(t / 1000 / 60 / 60 / 24);
                return d;
            },
        }
    }
</script>

<style lang="less" scoped>
    @keyframes pos {
		0% {
			left: 0;
		}
		100% {
			left: -100%;
		}
	}

	.ball{
		width: 100%;
		height: 100%;
		border-radius: 50%;
		overflow: hidden;
		position: relative;
		// border: 4rem solid rgba(90, 216, 166, 0.3);
        box-shadow: 0px 0px 2px 4px rgba(90, 216, 166, 0.3);
		
		.b-content {
			position: absolute;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(107, 230, 181, 1);
		}
		.b-top {
			width: 200%;
			height: 11%;
			position: absolute;
			left: 0;
			background-image: url('../../../assets/img/top.png');
			background-size: 50% 105%;
			animation: pos 1s linear infinite;
			background-repeat: repeat-x;
		}
	}
	
	.error{
		border:8px solid rgba(245, 170, 0, 0.3);
		.b-content {
			background-color: #F5AA00;
		}
		.b-top {
			background-image:  url('../../../assets/img/error1.png');
		}
	}



    .container {
        display: flex;
        .h(596);
        flex-direction: row;
        overflow: hidden;

        .container-left {
            width: 50%;
            display: flex;
            flex-direction: column;
            border-right: 1px solid rgba(0, 0, 0, 0.06);

            .equipment-header {
                .h(197);
                padding: 24rem;
                display: flex;

                .equipment-image {
                    .w(148);
                    .h(149);
                    border: 1px solid rgba(204, 204, 204, 0.5);
                    display: flex;
                    align-items: center;

                    >img {
                        width: 100%;
                        max-height: 100%;
                    }
                }

                .equipment-infomation {
                    flex: 1;
                    margin-left: 24rem;
                    margin-top: 8rem;
                    margin-bottom: 4rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .equipment-infomation-title {
                        display: flex;
                        justify-content: space-between;

                        :nth-child(1) {
                            font-size: 24rem;
                            font-weight: bold;
                            color: #333333;
                        }

                        :nth-child(2) {
                            font-size: 24rem;
                            font-weight: bold;
                        }
                    }

                    .equipment-infomation-content {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .h(78);

                        font-size: 16rem;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }

            .equipment-timer {
                width: 100%;
                height: 80rem;
                line-height: 80rem;
                padding: 0 24rem;
                // background-color: red;
                // padding: 0 4%;
                // display: flex;
                // align-items: center;

                .all-item {
                    width: 100%;
                    // padding: 2% 4%;
                    // display: flex;
                    // align-items: center;
                    overflow: hidden;
                    background-color: rgba(0, 43, 102, 0.04);
                    border-radius: 12rem;
                    padding: 0 25rem;
                    .yuan {
                        width: 58rem;
                        height: 58rem;
                        float: left;
                        position: relative;
                        margin-top: 12rem;
                        // background-color: blue;
                        .text{
                            font-size: 16rem;
                            color: #FFFFFF;
                            line-height: 58rem;
                            text-align: center;
                            position: absolute;
                            width: 100%;
                            font-weight: bold;
                            top: 0;
                            left: 0;
                        }
                    }

                    .titme {
                        font-size: 16rem;
                        display: flex;
                        align-items: center;
                        // padding-left: 8%;
                        float: right;
                        margin-right: 50rem;
                    }
                }

            }

            .diagramContainer {
                flex: 1;
                padding: 0 24rem;

                .header {
                    .h(40);
                    line-height: 400/108vh;
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    border-bottom: 1rem solid rgba(0, 0, 0, 0.12);
                }

                .diagram {
                    width: 100%;
                    height: 90%;

                    iframe {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .equipment-parameter {
                flex: 1;
                overflow-y: scroll;
                //火狐隐藏滚动条
                scrollbar-width: none;
            }

            ::-webkit-scrollbar {
                display: none;
            }
        }

        .container-right {
            width: 50%;
            overflow: hidden;
            overflow-y: auto;
            padding: 0;
        }

        // .container-right::-webkit-scrollbar {
        //     display: none;
        // }
    }
</style>